export default "__VITE_ASSET__Cez7JBJY__"